import type { ModelKey } from '../types'

const MGA_PREFIX = 'mga-'

export interface ModelOption {
  value: ModelKey
  label: string
}

export function formatModelLabel(model: ModelKey): string {
  const normalizedModel = model.startsWith(MGA_PREFIX) ? model.slice(MGA_PREFIX.length) : model

  return normalizedModel
    .split('-')
    .filter(Boolean)
    .map((part) => part[0].toUpperCase() + part.slice(1))
    .join(' ')
}

export function buildModelOptions(models: ModelKey[]): ModelOption[] {
  const availableModels = new Set(models)

  return models
    .filter(
      (model) =>
        !(model.startsWith(MGA_PREFIX) && availableModels.has(model.slice(MGA_PREFIX.length)))
    )
    .map((model) => ({ value: model, label: formatModelLabel(model) }))
    .sort((a, b) => a.label.localeCompare(b.label))
}
